/**
 * @typedef {Object} QueryObj
 * @property {string} query - graphql query string
 * @property {string} fragment - fragment for the query.
 */

/**
 * The query function aggregates queryObj's.
 * @param [QueryObj] queryObjList - An array of QueryObj's, or single queryObj.
 * @return { query: string }
 */

const query = (queryObjList) => {
    queryObjList =
        queryObjList instanceof Array ? queryObjList : [queryObjList];
    const queryList = queryObjList.map((it) => it.query || "");

    const fragmentList = [
        ...new Set(queryObjList.map((it) => it.fragment || "")),
    ];

    if (queryList.length === 0) {
        return "";
    }

    const EOL = `
`;
    const query = `query {
    ${queryList.join(EOL)}
}
    ${fragmentList.join(EOL)}
`;
    return { query };
};

/**
 * norm - normalizes graphql names, as per spec
 * (http://spec.graphql.org/June2018/#Name).
 * @param {string} str - string to normalize.
 * @return string
 */

const norm = (str) =>
    str.replace(/^[^_A-Za-z]*/, "").replace(/[^_0-9A-Za-z]*/g, "");

export { query as default, norm };
